import { Button, Icon } from 'darrius';
import { Step } from '../../../components';
import { Heading } from '../../../components/atoms/Heading/Heading';
import { Text } from '../../../components/atoms/Text/Text';
import styles from './RedefinePasswordSuccess.module.scss';

export const RedefinePasswordSuccess = () => {
  return (
    <Step.Root>
      <Step.Header>
        <Icon
          size={106}
          src={`${process.env.NEXT_PUBLIC_ASSETS_PREFIX}/images/icons/comunicacao.svg`}
          alt="Ícone de mensagem"
        />
        <Heading as="h2" size={2} className="spacing-stack-bottom-300">
          Senha alterada com sucesso!
        </Heading>
        <Text className={`spacing-stack-bottom-500 ${styles['hide-md']}`}>
          Clique no botão abaixo para voltar para o aplicativo do GetNinjas.
        </Text>
        <Text className={`spacing-stack-bottom-500 ${styles['hide-sm']}`}>
          Volte para o aplicativo do GetNinjas e acesse sua conta.
        </Text>
      </Step.Header>
      <Step.Body className={styles['hide-md']}>
        <Step.Actions>
          <Button.Link href="https://www.getninjas.com.br/home" type="button" size="small" fullWidth>
            Voltar para o aplicativo
          </Button.Link>
        </Step.Actions>
      </Step.Body>
    </Step.Root>
  );
};
